import { PaymentMethodType } from "./payment-gateway-types.ts";
import {
  getPlanPrice,
  planDurations,
  type PaymentPlan,
  type PlanDuration,
} from "./plan-types.ts";

export { planDurations, type PlanDuration };

export const calcPlanPriceForDuration = (
  method: PaymentMethodType,
  plan: PaymentPlan,
  duration: PlanDuration,
) => {
  if (!planDurations.includes(duration)) {
    throw new Error(`Unknown duration: ${duration}`);
  }
  return getPlanPrice(method, plan, duration);
};
